import createTaskAction from '@esentai/core/ducks/tasks/createTaskAction';

import { CREATE_QUESTION } from './types';

export const createQuestion = createTaskAction(CREATE_QUESTION);
